
import type { StateCreator } from "zustand";
import type { ConnectionState } from "../types/types";

export interface ConnectionSlice extends ConnectionState {
  setConnectionStatus: (status: ConnectionState["status"]) => void;
  setConnectionUrl: (url: string | null) => void;
  setConnectionError: (error: string | null) => void;
  setReconnectAttempts: (attempts: number) => void;
}

export const createConnectionSlice: StateCreator<ConnectionSlice> = (set) => ({
  status: "disconnected",
  url: null,
  error: null,
  reconnectAttempts: 0,

  setConnectionStatus: (status) => set({ status }),
  setConnectionUrl: (url) => set({ url }),
  setConnectionError: (error) => set({ error }),
  setReconnectAttempts: (attempts) => set({ reconnectAttempts: attempts }),
});
